module.exports = __webpack_public_path__ + "img/banner.f2d44366.svg";